import { render, staticRenderFns } from "./DisabilityPanel.vue?vue&type=template&id=0e25100f&scoped=true"
import script from "./DisabilityPanel.vue?vue&type=script&lang=js"
export * from "./DisabilityPanel.vue?vue&type=script&lang=js"
import style0 from "./DisabilityPanel.vue?vue&type=style&index=0&id=0e25100f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e25100f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
